// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"ff08ad95","656":"5063272f","756":"99297b0f","831":"766e76fc","968":"e16c2c02"}[chunkId] + ".chunk.js";
};